module.exports = __webpack_public_path__ + "img/温姆入口.09882d86.png";